import { createContext } from "react";

import type { NotificationsContextValue } from "./NotificationsContextValue";

export const NotificationsContext = createContext<NotificationsContextValue | null>(null);

NotificationsContext.displayName = "NotificationsContext";
